import queryString from 'utils/query-string';

const redirectConfig = {
  'tmpl/fe_tool/fetal_movement/dist/pages/Index/Index':
    '/pages/fetal_movement/pages/index'
};

export const redirect = function (location) {
  const { query = {} } = location;
  const { fe_path } = query;
  if (!fe_path) return false;
  const pathname = redirectConfig[fe_path];
  if (pathname) {
    delete query.fe_path;
    return {
      pathname,
      search: queryString.stringify(query)
    };
  }
  return false;
};
